// extracted by mini-css-extract-plugin
export default {"confirmation":"jIoCWQRkfFWt0BflOgty","danger-zone-label":"k08otYj5NQ5uQY2qGz1A","dialog-title-danger-zone":"qOBtMxvCr4UkN23GdDyF","danger-zone-confirm":"FUhSpwPaJTJqwv1IGpmH"};